"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../hooks/useLangContext");
const theme_1 = __importDefault(require("../../theme"));
const fonts_1 = require("../../theme/foundations/fonts");
const PdfHeaderComponent = () => {
    return react_2.default.createElement(react_1.Box, null);
};
const PdfHeader = ({ lang, ...props }) => (react_2.default.createElement(react_1.ChakraProvider, { theme: theme_1.default },
    react_2.default.createElement(fonts_1.Fonts, null),
    react_2.default.createElement(useLangContext_1.LangContextProvider, { lang: lang },
        react_2.default.createElement(PdfHeaderComponent, { ...props }))));
exports.default = PdfHeader;
